import { Product } from '../models/product';
import { dateMapper } from './date.mapper';

/**
 * Map dto to model
 * @param {object} dto Dto.
 * @returns {Product}
 */
function fromDto(dto) {
  return {
    id: dto.id,
    name: dto.name,
    description: dto.description,
    code: dto.code,
    unitPrice: dto.unit_price,
    typeId: dto.type_id,
    expirationTerm: dto.expiration_term,
    editDate: dateMapper.fromDto(dto.editDate),
  };
}

export const productMapper = {
  fromDto,
};
